module.exports = __webpack_public_path__ + "static/media/more-vertical.cb5a271a.svg";